import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import axios from 'axios';
import { CiEdit } from 'react-icons/ci';

const ComplaintTypeMaster = () => {
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    const [showAdd, setShowAdd] = useState(false);
    const [complaintype, setComplainType] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedCtype, setSelectedCtype] = useState('');

    const [searchTerm, setSearchTerm] = useState('');

    const [form, setForm] = useState({
        c_type: '',
        name: '',
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();


        if (isEditMode) {
            const sendData = new FormData();

            sendData.append("c_type", form.c_type);
            sendData.append("name", form.name);

            try {
                const res = await axios.put(
                    `https://api.skyguard.group/api/edit-complaintype-master/${form.id}`,
                    sendData,
                    { headers: { "Content-Type": "application/json", } }
                );


                showToast('Complaint type updated successfully!', 'success');
                fetchCtype();
                setShowAdd(false);
                setForm({
                    c_type: '',
                    name: '',
                })
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to update Complaint type  !', 'danger');
            }
        } else {
            const duplicate = complaintype.some(
                (item) =>
                    item.c_type &&
                    item.c_type.toLowerCase().trim() === form.c_type.toLowerCase().trim()
            );
            if (duplicate) {
                showToast('Complaint Type already exists!', 'warning');
                return; // stop submission
            }
            const sendData = new FormData();

            sendData.append("c_type", form.c_type);
            sendData.append("name", form.name);



            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-complaintype-master",
                    sendData,
                    { headers: { "Content-Type": "application/json", } }
                );


                showToast('Complaint type Added successfully!', 'success');
                fetchCtype();
                setShowAdd(false);
                setForm({
                    c_type: '',
                    name: '',
                })
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to Add Complaint type  !', 'danger');
            }
        }
    }


    const fetchCtype = async () => {

        try {
            const resCtype = await axios.get('https://api.skyguard.group/api/fetch-complaintype-master');
            setComplainType(resCtype.data);

        } catch (error) {
            console.log(error)
        }
    };


    useEffect(() => {

        fetchCtype();
    }, []);


    const handleEdit = (c) => {
        setForm({
            id: c.id || '',
            c_type: c.c_type || '',
            name: c.name || '',
        });
        setIsEditMode(true);
        setShowAdd(true);
        setSelectedCtype(c);
    }


        const filterComplaint = complaintype.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
          (tt.name && tt.name.toLowerCase().includes(term)) ||
          (tt.c_type && tt.c_type.toString().toLowerCase().includes(term)) 
         
        );
      });
    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />


                  
                        <h3 className='my-3 fw-bold fs-5 golos'>Complaint Type</h3>


                        {/* <button className="btn btn-success" onClick={() => setShowAdd(true)}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button> */}


                        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

                            <div className="mb-2 w-50 w-md-50 pe-md-2">
                                <input
                                    className="form-control w-100"
                                    list="datalistOptions"
                                    placeholder="Search by Name,Type...."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>


                            <div className="mb-2">
                                <button className="btn btn-success" onClick={() => setShowAdd(true)}>
                                    <AiOutlinePlusCircle size={20} /> Add
                                </button>
                            </div>
                        </div>
                    



                    {showAdd && (


                        <div className='card p-3 mb-3  '>
                            <form className='row' onSubmit={handleSubmit} >


                                                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.c_type}
    </span>
  </div>
)}

                                <div className="col-md-6 my-2">
                                    <label htmlFor='name' className="form-label fw-medium" > Complaint  Type</label>
                                    <input type="text" className="form-control" name="c_type" placeholder="Enter here..." value={form.c_type} onChange={handleInputChange} required />
                                </div>

                                <div className="col-md-6 my-2">
                                    <label htmlFor='name' className="form-label fw-medium" > Name</label>
                                    <input type="text" className="form-control" name="name" placeholder="Enter here..." value={form.name} onChange={handleInputChange} required />
                                </div>

                                <div className='col-12 text-end'>
                                    <button type="submit" className='btn btn-success'>
                                        {isEditMode ? 'Update' : 'Save'} Type
                                    </button>


                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAdd(false);
                                        setIsEditMode(false);
                                        setForm({
                                            c_type: '',
                                            name: '',
                                        })
                                    }}>
                                        Cancel
                                    </button>

                                </div>


                            </form>
                        </div>
                    )}



                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>

                            <thead className='table-info'>
                                <tr>
                                       <th scope='col'>Action</th>
                                    <th scope='col'>SN</th>
                                    <th scope='col'> Name </th>
                                    <th scope='col'>Complaint Type </th>
                                 
                                </tr>
                            </thead>
                            <tbody>
                                {filterComplaint.map((c, idx) => (
                                    <tr key={idx} >
                                          <td className='cursor-pointer' onClick={() => handleEdit(c)}>< CiEdit size={20} /></td>

                                        <td>{idx + 1}</td>
                                        <td>
                                            {c.name}
                                        </td>
                                        <td>
                                            {c.c_type}
                                        </td>
                                      

                                    </tr>


                                ))}
                            </tbody>
                        </table>
                    </div>




                </div>
            </div>


        </>
    )
}

export default ComplaintTypeMaster